//------------------imports----------------
import { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  FormControl,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  Autocomplete,
  AppBar,
} from "@mui/material";
import {
  CON_STATUS_ACTIVE,
} from "../../utils/sys/Constants";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddToolbar from "../../components/common/AddToolbar";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { SETTINGS_API_19, SETTINGS_API_22 } from "../../api/ApiModel";
import { useSelector } from "react-redux";

const querys = ["yes", "No"];

const OtherChanges = () => {
  //---------------------hooks---------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME, CATTYPE } =
    SYS_USER.USER_PARAM || {};
  const [data, setData] = useState(null);
  const [datacharge, setDatacharge] = useState(null);
  const [data1, setData1] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { selectedItem, orderTypeCode, orderType } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(true);
  const isEdit = location.state?.actionText === "Edit";
  const options1 = [
    { label: "Gross", value: "G" },
    { label: "Nett", value: "N" },
  ];
  const gotToView = () => {
    navigate("/votherchange");
  };

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    CHARGETYPE: "",
    CHARGERATE: "",
    CHARGEFOR: "",
    CHARGECODE: "",
  });

  useEffect(() => {
    fetchDataordertype();
  }, []);

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        CHARGETYPE: selectedItem.CHARGETYPE,
        CHARGERATE: String(selectedItem.CHARGERATE),
        CHARGEFOR: selectedItem.CHARGEFOR,
        CHARGECODE: String(selectedItem.CHARGECODE),

        ORDERTYPECODE: String(selectedItem.ORDERTYPECODE),
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    // Validate charges whenever the selected order type changes
    if (selectedItemDetails.ORDERTYPECODE) {
      fetchData();
    }
  }, [selectedItemDetails.ORDERTYPECODE]);

  useEffect(() => {
    fetchData();
  }, []);

  //functions
  const fetchDataordertype = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_22, "get", {
        CATTYPE,
        STS: CON_STATUS_ACTIVE,
      });
      setData1(result); // Assuming result contains the array of order types
    } catch (err) {
      setError(err);
    }
  };

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_19, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
        ORDERTYPECODE: selectedItemDetails.ORDERTYPECODE || 0,
      });
      setDatacharge(result);
    } catch (err) {
      setError(err);
    }
  };
  //postapi
  const handleConfirmClick = async () => {
    const { CHARGEFOR, CHARGERATE, CHARGETYPE, ORDERTYPE, ORDERTYPECODE } =
      selectedItemDetails;

    const requiredFields = [
      { name: "ORDERTYPE", value: ORDERTYPECODE, label: "Order Type" },
      { name: "CHARGETYPE", value: CHARGETYPE, label: "Charge Type" },
      { name: "CHARGERATE", value: CHARGERATE, label: "Charge Rate" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    if (datacharge) {
      const isDuplicate = datacharge.some((item) => 
          item.CHARGECODE != selectedItemDetails.CHARGECODE &&
          item.CHARGETYPE.toLowerCase().trim() === CHARGETYPE.toLowerCase().trim() 
      );

      if (isDuplicate) {
        setSnackbarMessage("Charge Type already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE, // Assuming 'A' for active status
      ENUSER: USERNAME,
      ORDERTYPECODE: isEdit
        ? String(orderTypeCode)
        : String(selectedItemDetails.ORDERTYPECODE || ""),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_19, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        ORDERTYPE: "",
        CHARGETYPE: "",
        CHARGERATE: "",
        CHARGEFOR: "",
        CHARGECODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
    setTimeout(() => {
      navigate("/votherchange");
    }, 2000);
  };

  //handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };
  //validations
  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      setError("");
      handleInputChange(event);
    } else {
      // setError("Only letters and spaces are allowed.");
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters and spaces are allowed.",
      }));
    }
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    // Regular expression to allow numbers or an empty string
    const regex = /^(\d+(\.\d{0,2})?|\.?\d{1,2})$/;

    if (value === "") {
      // Allow empty string to clear the field
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error
      handleInputChange({ target: { name, value: "" } }); // Update input value
    } else if (regex.test(value) && parseFloat(value) <= 100) {
      // Valid input: numbers with up to two decimal places below 100
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error
      handleInputChange(event); // Update input value
    } else {
      // Invalid input
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]:
          "Only numbers below 100 with up to two decimal places are allowed.",
      }));
    }
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      ORDERTYPE: "",
      CHARGETYPE: "",
      CHARGERATE: "",
      CHARGEFOR: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">{
          isEdit ? "Edit Other Charges" : "Create Other Charges"
          }</Link>
              </Breadcrumbs>
            </Grid>    
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit ? "Edit Other Charges" : "Create Other Charges",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid container item spacing={2} xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              {/* Conditionally render Autocomplete based on isEdit */}
              {!isEdit ? (
                <Autocomplete
                  options={data1 || []}
                  getOptionLabel={(option) => option.ORDERTYPE || ""}
                  value={
                    data1
                      ? data1.find(
                          (item) =>
                            item.ORDERTYPECODE ===
                            selectedItemDetails.ORDERTYPECODE
                        ) || null
                      : null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "ORDERTYPE",
                        value: newValue ? newValue.ORDERTYPE : "", // Set ORDERTYPE
                      },
                    });
                    handleInputChange({
                      target: {
                        name: "ORDERTYPECODE",
                        value: newValue ? newValue.ORDERTYPECODE : "", // Set ORDERTYPECODE
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Order Type<span style={{ color: "red" }}> *</span>
                        </span>
                      }
                      size="small"
                      fullWidth
                      variant="outlined"
                      error={Boolean(errors.ORDERTYPE)}
                      helperText={errors.ORDERTYPE}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                />
              ) : (
                // When in edit mode, show the selected order type details
                <TextField
                  label={
                    <span>
                      Order Type<span style={{ color: "red" }}> *</span>
                    </span>
                  }
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={orderType} // Pass the ORDERTYPECODE as value// Display the selected ORDERTYPE
                  InputProps={{
                    readOnly: true, // Makes the TextField read-only
                  }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label={
                  <span>
                    Charge Rate (%)<span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                type="text"
                variant="outlined"
                autoComplete="off"
                name="CHARGERATE"
                value={selectedItemDetails.CHARGERATE || ""}
                onChange={handlenumInputValidation}
                error={Boolean(errors.CHARGERATE)}
                helperText={errors.CHARGERATE}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                label={
                  <span>
                    Charge Type<span style={{ color: "red" }}> *</span>
                  </span>
                }
                size="small"
                fullWidth
                type="float"
                variant="outlined"
                autoComplete="off"
                name="CHARGETYPE"
                value={selectedItemDetails.CHARGETYPE}
                onChange={handleInputValidation}
                error={Boolean(errors.CHARGETYPE)}
                helperText={errors.CHARGETYPE}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl size="small" fullWidth>
                <Autocomplete
                  options={options1}
                  getOptionLabel={(option) => option.label}
                  value={
                    options1.find(
                      (option) => option.value === selectedItemDetails.CHARGEFOR
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: {
                        name: "CHARGEFOR",
                        value: newValue ? newValue.value : "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Charge Applied"
                      variant="outlined"
                      size="small"
                      helperText={error?.CHARGEFOR}
                      error={!!error?.CHARGEFOR}
                    />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? "Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default OtherChanges;
